import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useDeleteOfferMutation = createMutationHook(OffersApiClient.deleteOffer, {
  mutationKey: ['deleteOffer'],
})
